import {
  applyTheme,
  isAppWebView,
  THEME_BOOTSTRAP_SCRIPT,
  THEME_EVENT_NAME,
} from "@/theme/runtime";

// Evaluate the current URL each time so client-side route changes stay in sync.
export function shouldPersistArtworkShareTheme(targetWindow: Window): boolean {
  return (
    isAppWebView(targetWindow) ||
    !/^\/(?:[^/]+\/)?ai\/share\/?$/.test(targetWindow.location.pathname)
  );
}

// This landing page follows the recipient's system only outside the App.
export function initializeArtworkShareTheme(): () => void {
  if (typeof window === "undefined" || isAppWebView(window))
    return () => undefined;
  const appearance = window.matchMedia?.("(prefers-color-scheme: dark)");
  const sync = () => {
    if (isAppWebView(window)) return;
    const theme = appearance?.matches ? "dark" : "light";
    if (document.documentElement.dataset.theme !== theme)
      applyTheme(theme, { persist: false });
  };
  sync();
  appearance?.addEventListener?.("change", sync);
  window.addEventListener(THEME_EVENT_NAME, sync);
  return () => {
    appearance?.removeEventListener?.("change", sync);
    window.removeEventListener(THEME_EVENT_NAME, sync);
  };
}

// Runs after the common bootstrap, before paint. Host values remain authoritative.
export const ARTWORK_SHARE_THEME_BOOTSTRAP = `(function () {
  var ua = (window.navigator.userAgent || '').toLowerCase();
  if (ua.indexOf('seekee') >= 0 || ua.indexOf('buscari') >= 0 || 'quan_function' in window) {
    ${THEME_BOOTSTRAP_SCRIPT}
    return;
  }
  var theme = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  document.documentElement.setAttribute('data-theme', theme);
  document.documentElement.style.colorScheme = theme;
  var meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', theme === 'dark' ? '#0F1115' : '#FFFFFF');
})();`;
